import React from 'react';
import { SubscriptionFeature } from '../../types/subscription';
import { useFeatureGate } from '../../hooks/useFeatureGate';
import UpgradePrompt from './UpgradePrompt';

interface FeatureGateProps {
  feature: SubscriptionFeature;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showUpgradePrompt?: boolean;
  featureName?: string;
}

const FeatureGate: React.FC<FeatureGateProps> = ({
  feature,
  children,
  fallback,
  showUpgradePrompt = true,
  featureName,
}) => {
  const { hasFeature, loading } = useFeatureGate(feature);

  // Пока загружается - показываем null или можно добавить скелетон
  if (loading) {
    return null;
  }

  // Если есть доступ - показываем контент
  if (hasFeature) {
    return <>{children}</>;
  }

  // Если нет доступа и есть кастомный fallback
  if (fallback) {
    return <>{fallback}</>;
  }

  // Если нет доступа и нужно показать UpgradePrompt
  if (showUpgradePrompt) {
    return <UpgradePrompt feature={feature} featureName={featureName} />;
  }

  // Если нет доступа и не нужно ничего показывать
  return null;
};

export default FeatureGate;
